module.exports = __webpack_public_path__ + "assets/img/slogan-c20c5b86.png";